
import React, { useState, useEffect } from 'react';
import style from './style.module.css';
import Modal from '../Modal';
import Collection from '../Collection';

import HistoryItem from '../HistoryItem';

const HistoryModal = props => {
    return (
        <Modal {...props} navigationTitle={props.title}>
            <div className={style.content}>
                <div className={style.tipContainer}>
                    <div className={style.TipItem}>
                        {/* <div className={style.tipIcon}>Lightbulb</div> */}
                        {/* lightbulb */}
                        <div className={style.tipInfo}>
                            <div className={style.tipTitle}>See How You're Tracking</div>
                            <div className={style.tipDescription}>Remember what activities you did on each day and see what you're on track for. Then make an effort to do more of that!</div>
                            {/* {itemData.description && itemData.description.length ? <div className={style.description}>{itemData.description}</div> : null} */}
                        </div>
                    </div>
                    <div className={style.tipOverlay}>Quick Tip</div>
                </div>
                <Collection
                    listLayout
                    items={props.steps}
                    itemType={props.kind}
                    component={HistoryItem} />
            </div>
        </Modal>
    );

};

export default HistoryModal;
